import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";

import { EligibilityRequirements } from "../steps/EligibilityRequirements/EligibilityRequirements";
import {
  OnboardingContext,
  OnboardingModuleEligibilityRequirements,
  OnboardingStep
} from "../types";
import { selectorIsAllRequirementsComplete } from "../../Requirements/selectors/selectorIsAllRequirementsComplete";
import { getIsGeneralRequirement } from "../../Requirements/utils";

const getStatus = (requirements: IRequirementResponse[]) => {
  if (selectorIsAllRequirementsComplete(requirements)) {
    return "Complete";
  }

  return "None";
};

export const getEligibilityRequirementsStepConfig = (
  _: OnboardingModuleEligibilityRequirements,
  __: OnboardingContext,
  requirements?: IRequirementResponse[]
): OnboardingStep | null => {
  const nonGeneralRequirements = requirements?.filter(
    r => !getIsGeneralRequirement(r)
  );

  // When data hasn't loaded yet (undefined), return a placeholder step
  // so loadStep can show a loading state instead of removing the step entirely.
  // Removing the step causes a redirect to the first onboarding step.
  if (requirements && !nonGeneralRequirements?.length) {
    return null;
  }

  const slug = "requirements";

  const status = nonGeneralRequirements
    ? getStatus(nonGeneralRequirements)
    : "None";

  return {
    title: "Additional client requirements",
    slug,
    component: EligibilityRequirements,

    status,
    result: {
      Complete: {
        title: "Your eligibility requirements are complete",
        description:
          "Your eligibility requirements are complete. Your eligibility requirements from your clients are complete. If additional requirements are needed in the future, these tasks will appear on your “Get started” homepage. Click continue for the next step."
      }
    }
  };
};
